import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/vendas/vendas/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findVendas({
  empresa_cnpj,
  where = {},
  include,
  sort,
  wherein = {},
  per_page = 50,
  id = null,
}) {
  let query = "";
  Object.keys(where).forEach((value) => {
    query += `&where[${value}]=${where[value]}`;
  });

  let queryWhereIn = "";
  Object.keys(wherein).forEach((row) => {
    queryWhereIn += `&wherein[${row}]=${wherein[row]}`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${query}${queryWhereIn}${
      include ? `&include=${include}` : ""
    }${sort ? `&sort=${sort}` : ""}&per_page=${per_page}`,
    "GET",
    headers
  );
}

export async function findSalesByClient({
  empresa_cnpj,
  idcliente = "",
  idempresa = "",
  tipo = "Venda",
  orderNumber = "",
  startDate = "",
  finalDate = "",
  per_page = 50,
  usedSales = false,
}) {
  return search(
    `${path}/porcliente/${idcliente}?empresa_cnpj=${empresa_cnpj}&idempresa=${idempresa}&tipo=${tipo}&per_page=${per_page}${
      usedSales ? `&usedSales=true` : ""
    }&orderNumber=${orderNumber}&startDate=${startDate}&finalDate=${finalDate}`,
    "GET",
    headers
  );
}

export async function createVenda(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export async function findSituacaoVendas({ empresa_cnpj, id }) {
  return search(
    `${process.env.REACT_APP_URL_API_ERP}/erp/vendas/situacaovendas/v1${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}&where[ativo]=S`,
    "GET",
    headers
  );
}

export async function updateVenda(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}
